import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import { FullSchema } from "@/shared/models/FullSchema";

export const FULL_SCHEMA_INITIALIZATION: FullSchema = {
  title: "",
  description: "",
  type: "object",
  properties: {},
  required: []
};

export const GROUP_SCHEMA_INITIALIZATION: GroupFullSchema = {
  allOf: [FULL_SCHEMA_INITIALIZATION],
  type: "object"
};

export const SAVE_INFO_GROUP_EVENTS = {
  ADD: "addInfoGroup",
  UPDATE: "updateInfoGroup",
  ERROR: "error",
  CANCEL: "cancelInfoGroup"
};

export const SAVE_INFO_GROUP_CONSTANTS = {
  INACTIVE_ELEMENTS: "Este grupo de información contiene elementos inactivos."
};
